(function () {
  Flint.file("mframework/views/checkboxPicker.js", function (require) {
    /*
      props:
        options: [
          {label, value}
        ]
    */

    Flint.staticStyles("CheckboxPicker", {
      "$label": "#_flintapp label.CheckboxPicker, #_flintapp .CheckboxPicker.label, #_flintapp .ViewCheckboxPicker.label, #_flintapp .CheckboxPicker > .label"
    }, {
      "$label": {
        cursor: 'pointer'
      }
    });
    Flint.view("CheckboxPicker", function (view, on, $) {
      var pro = initPro(view, {
        options: atom(),
        initialValues: M.listAtom([]),
        values: M.listAtom()
      });

      var selectedValues = atom(pro.initialValues.get());

      pro.values.react(function (values) {
        if (values != null) {
          selectedValues.set(values);
        }
      });

      selectedValues.reactor(function (selectedValues) {
        if (view.props.onChange) {
          view.props.onChange({ selectedValues: selectedValues });
        }
      }).start();

      var onChange = function onChange(e) {
        var value = e.target.value;
        var index = selectedValues.get().indexOf(value);
        if (index >= 0) {
          selectedValues.set(selectedValues.get().splice(index, 1));
        } else {
          selectedValues.set(selectedValues.get().push(value).sort(M.util.compare));
        }
      };view.render(function () {
        return view.el(
          ["content", 1],
          null,
          Flint.range(pro.options.get()).map(function (_, _index) {
            return view.el(
              ["label", 1, _, _index],
              { repeat: pro.options.get() },
              view.el(["input", 1, _, _index], { type: "checkbox",
                value: _.value,
                checked: selectedValues.get().indexOf(_.value) >= 0,
                onChange: onChange
              }),
              _.label
            );
          })
        );
      });
    });
  })
})();
//# sourceMappingURL=checkboxPicker.js.map
